import i18n from 'i18next';
import LngDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

const initializeI18n = async () => {
  const userLanguage = localStorage.getItem('i18nextLng') || navigator.language || 'en';
  try {
    await i18n
      .use(LngDetector)
      .use(initReactI18next)
      .init({
        fallbackLng: {
          default: ['en'],
        },
        lng: userLanguage,
        ns: ['common', 'homepage', 'pnl', 'csv', 'date'],
        defaultNS: 'common',
        debug: false,
        resources: {
          en: {
            common: (await import('watchtower-ui/locales/en/common.json')).default,
            homepage: (await import('watchtower-ui/locales/en/homepage.json')).default,
            pnl: (await import('watchtower-ui/locales/en/pnl.json')).default,
            csv: (await import('watchtower-ui/locales/en/csv.json')).default,
            date: (await import('watchtower-ui/locales/en/date.json')).default,
          },
          pt: {
            common: (await import('watchtower-ui/locales/pt/common.json')).default,
            homepage: (await import('watchtower-ui/locales/pt/homepage.json')).default,
          },
          sp: {
            common: (await import('watchtower-ui/locales/sp/common.json')).default,
            homepage: (await import('watchtower-ui/locales/sp/homepage.json')).default,
          },
        },
        detection: {
          order: ['navigator', 'localstorage'],
          lookupLocalStorage: 'i18nextLng',
          caches: ['localStorage'],
        },
      });
  } catch (error) {
    console.error('i18n initialization failed', error);
  }
};

await initializeI18n();

export const t = i18n.t.bind(i18n);
export default i18n;
